module.exports = __webpack_public_path__ + "img/retail01.27c89e8a.png";